export default __webpack_public_path__ + "static/media/img3.c1b1588c.PNG";